import { useMemo } from 'react'
import HotTable from '@handsontable/react'
import { t } from '@lingui/core/macro'
import { CircularProgress } from '@mui/material'
import { useUserActivitiesParams } from '@admin/organization/activities/hooks/useUserActivitiesParams'
import { LICENSE_KEY } from '@global/constants/handsontable'
import { useUserActivtities } from '@global/hooks/queries/user-activities'
import { usePagination } from '@taxonomy-translation/components/pagination/usePagination'
import { cssTable } from './styles'
import { Pagination } from '../pagination'

const emptyResponse = {
  metadata: {
    limit: 0,
    totalItems: 0,
    next: undefined,
  },
  data: [],
} as const

export const UserActivityLogTable = () => {
  const { cursor, page, onNextPage, onPreviousPage, isPreviousAvailable, goToFirstPage } =
    usePagination()

  const columns = [
    { data: 'timestamp', title: t`Timestamp` },
    { data: 'username', title: t`Username` },
    { data: 'configuredObject', title: t`Configured Object` },
    { data: 'objectName', title: t`Object Name` },
    { data: 'operation', title: t`Operation` },
    { data: 'objectId', title: t`Object ID` },
  ]

  const paginationParams = useMemo(
    () => ({
      cursor,
    }),
    [cursor],
  )
  const { timeFrom, timeTo } = useUserActivitiesParams()

  const { data = emptyResponse, isLoading } = useUserActivtities({
    ...paginationParams,
    timeFrom,
    timeTo,
    limit: 30,
  })
  const { data: activitiesList, metadata } = data

  const handleNextPage = () => {
    onNextPage(metadata?.next)
  }

  if (isLoading) {
    return (
      <div className="flex flex-1 justify-center items-center">
        <CircularProgress />
      </div>
    )
  }

  return (
    <div data-testid="user-activity-log-table">
      <HotTable
        css={cssTable}
        data={[...activitiesList]}
        colHeaders={columns.map(col => col.title)}
        columns={columns}
        columnSorting={false}
        licenseKey={LICENSE_KEY}
        readOnly
        height="auto"
        stretchH="all"
      />
      <div
        className="sticky bottom-0 right-0 border-b border-l border-r rounded-b"
        style={{
          backgroundColor: '#F7F7F9',
          borderColor: '#E7E7E9',
        }}
      >
        <Pagination
          page={page}
          limit={metadata.limit}
          total={metadata.totalItems}
          isPreviousAvailable={isPreviousAvailable}
          nextCursor={metadata?.next}
          onNextClick={handleNextPage}
          onPreviousClick={onPreviousPage}
          goToFirstPage={goToFirstPage}
        />
      </div>
    </div>
  )
}
